import { InjectionToken } from '@angular/core';
import { PrintDom } from './print-dom';

export const PRINT_DOM_INSTANCE = new InjectionToken<PrintDom>('PRINT_DOM_INSTANCE');
export const PRINT_DOM_DATA_DEFAULT = new InjectionToken<Record<string, any>>('PRINT_DOM_DATA_DEFAULT');
